module.exports = __webpack_public_path__ + "static/media/logo-gein-branco.63cb9544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo-gein-branco.png
// module id = 1126
// module chunks = 0